"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameResponseToJSON = exports.OWGameResponseFromJSONTyped = exports.OWGameResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OWGameResponseFromJSON(json) {
    return OWGameResponseFromJSONTyped(json, false);
}
exports.OWGameResponseFromJSON = OWGameResponseFromJSON;
function OWGameResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, _1.OWGameFromJSONTyped)(json, ignoreDiscriminator)), { 'hasUserStats': !(0, runtime_1.exists)(json, 'hasUserStats') ? undefined : json['hasUserStats'], 'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'], 'slug': !(0, runtime_1.exists)(json, 'slug') ? undefined : json['slug'], 'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'], 'seo': !(0, runtime_1.exists)(json, 'seo') ? undefined : (0, _1.OWGameSEOFromJSON)(json['seo']), 'steamMatch': !(0, runtime_1.exists)(json, 'steamMatch') ? undefined : (0, _1.OWGameSteamMatchFromJSON)(json['steamMatch']), 'steamData': !(0, runtime_1.exists)(json, 'steamData') ? undefined : (0, _1.OWGameSteamDataFromJSON)(json['steamData']), 'steamLogoUrl': !(0, runtime_1.exists)(json, 'steamLogoUrl') ? undefined : json['steamLogoUrl'], 'steamDataLastRefreshed': !(0, runtime_1.exists)(json, 'steamDataLastRefreshed') ? undefined : (new Date(json['steamDataLastRefreshed'])), 'steamNews': !(0, runtime_1.exists)(json, 'steamNews') ? undefined : json['steamNews'] });
}
exports.OWGameResponseFromJSONTyped = OWGameResponseFromJSONTyped;
function OWGameResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, _1.OWGameToJSON)(value)), { 'hasUserStats': value.hasUserStats, 'steamAppId': value.steamAppId, 'slug': value.slug, 'timeTrackedGame': value.timeTrackedGame, 'seo': (0, _1.OWGameSEOToJSON)(value.seo), 'steamMatch': (0, _1.OWGameSteamMatchToJSON)(value.steamMatch), 'steamData': (0, _1.OWGameSteamDataToJSON)(value.steamData), 'steamLogoUrl': value.steamLogoUrl, 'steamDataLastRefreshed': value.steamDataLastRefreshed === undefined ? undefined : (value.steamDataLastRefreshed.toISOString()), 'steamNews': value.steamNews });
}
exports.OWGameResponseToJSON = OWGameResponseToJSON;
